import { AuthAPI } from "@api/Auth.api";
import EPublicRoutes from "@core-types/routes.enum";
import { useAppNavigate } from "@hooks/language/useAppNavigate";
import HomePage from "@modules/home/pages/HomePage";
import useUserStore from "@store/user.store";
import { useEffect } from "react";

const DiscordAuthCallback = () => {
  const { navigate } = useAppNavigate();
  const user = useUserStore();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (code) {
      AuthAPI.loginDiscord(code)
        .then((res) => {
          user.setToken(res.data.token);
        })
        .finally(() => navigate(EPublicRoutes.HOME));
    }
  }, [navigate, user.setToken]);

  return <HomePage />;
};

export default DiscordAuthCallback;
